<template src="./vertical-keyword.component.html"></template>
<style scoped src="./vertical-keyword.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import debounce from 'debounce';
import Sidebar from '@/components/sidebar/sidebar.component.vue';
import api from '@/api';
import {KeywordV2, Vertical} from '@/models';

export default Vue.extend({
  data() {
    return {
      msg: 'Assign Vertical to Keywords',
      keywords: [] as KeywordV2[],
      showLoading: false,
      search: '',
      limit: 25,
      page: 1,
      quantity: 0,
      verticals: [] as string[],
      market: '',
      mkts: [] as string[],
      // @ts-ignore
      debouncedSearch: debounce(this.searchKeywords, 500),
    };
  },
  components: {
    Sidebar,
  },
  async created() {
    await this.refreshKeywords();
    const keywords = await api.execute('get', '/keywords/info/quantity');
    this.quantity = keywords.count;

    const verticals = await api.execute('get', '/verticals') as Vertical[];
    this.verticals.push('null');
    for (const vertical of verticals) {
      this.verticals.push(vertical.name);
    }

    const markets = await api.execute('get', '/markets');

    for (const market of markets) {
      this.mkts.push(market.code);
    }
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  watch: {
    search() {
      this.debouncedSearch();
    },
    market() {
      this.refreshKeywordsWithFilters();
    },
  },
  methods: {
    async refreshKeywordsNoFilters() {
      this.search = '';
      this.market = '';
      this.page = 1;
      await this.refreshKeywords();
    },
    async refreshKeywordsWithFilters() {
      this.page = 1;
      await this.refreshKeywords();
    },
    async refreshKeywords() {
      this.keywords = [];
      this.showLoading = true;
      let url = `/keywords?limit=${this.limit}&page=${this.page}&null=true`;
      if (this.search) {
        url += `&search=${encodeURIComponent(this.search)}`;
      }
      if (this.market) {
        url += `&market=${this.market}`;
      }
      this.keywords = await api.execute('get', url);
      this.showLoading = false;
    },
    async searchKeywords() {
      this.keywords = [];
      this.showLoading = true;
      if (this.search === '') {
        this.page = 1;
        await this.refreshKeywords();
      } else {
        await this.refreshKeywords();
      }
      this.showLoading = false;
    },
    async save() {
      const response = [];
      for (const keyword of this.keywords) {
        if (keyword.vertical != null && keyword.vertical !== 'null') {
          response.push(
            await api.execute('put', `/keywords?keyword=${encodeURIComponent(keyword.keyword)}`, {
              vertical: keyword.vertical,
            }),
          );
          console.log(response);
        }
      }

      if (response.length > 0) {
        alert('Keyword updated correctly');
        await this.refreshKeywordsNoFilters();
      }
    },
  },
});
</script>
